import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-welcome-intro',
  styleUrls: ['./welcome-intro.component.scss'],
  templateUrl: './welcome-intro.component.html'
})
export class WelcomeIntroComponent implements OnInit, OnDestroy {

  constructor(private router: Router) {}

  ngOnInit() {
    window.addEventListener('scroll', this.scroll, true);
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
  }

  public goHome(): void {
    this.router.navigate(['/home']);
  }

  private scroll = (event: any): void => {
    const h = document.documentElement;
    const b = document.body;
    const st = 'scrollTop';
    const sh = 'scrollHeight';
    const percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;

    // Landing Section
    const goHome = document.getElementById('goHome');
    const home1 = document.getElementById('home1');
    const home2 = document.getElementById('home2');
    const home3 = document.getElementById('home3');
    const scrollIcn = document.getElementById('scrollIcn');

    if (percent >= 0 && percent <= 5) {
      home1.classList.remove('hide-element');
      console.log('show home1');
    }

    if (percent >= 2 && percent <= 5) {
      home1.classList.add('hide-element');
      console.log('hide home1');
    }

    if (percent >= 4 && percent <= 7) {
      home2.classList.remove('hide-element');
      console.log('show home2');
    }

    if (percent >= 8 && percent <= 11) {
      home2.classList.add('hide-element');
      console.log('hide home2');
    }

    if (percent >= 15 && percent <= 21) {
      home3.classList.remove('hide-element');
      console.log('show home3');

      if (home1.classList.contains('hide-element') && home2.classList.contains('hide-element')) {
        console.log('scroll working');
      } else {
        home1.classList.add('hide-element');
        home2.classList.add('hide-element');
      }
    }

    if (percent >= 23) {
      scrollIcn.classList.add('hide-mouse');
    }

    if (percent >= 25) {
      goHome.classList.add('show');
    }
  }
}
